import React from 'react';
import { cn } from './cn';

export interface SkeletonProps {
  variant?: 'text' | 'title' | 'block' | 'circle';
  width?: string | number;
  height?: string | number;
  className?: string;
}

const base = 'animate-pulse bg-[var(--line-200)]';

export const Skeleton: React.FC<SkeletonProps> = ({ variant = 'text', width, height, className }) => (
  <span
    aria-hidden="true"
    className={cn(
      base,
      variant === 'text' && 'block h-4 rounded-[var(--radius-sm)]',
      variant === 'title' && 'block h-7 rounded-[var(--radius-sm)]',
      variant === 'block' && 'block rounded-[var(--radius-lg)]',
      variant === 'circle' && 'block rounded-full',
      className,
    )}
    style={{ width, height }}
  />
);

export interface SkeletonGroupProps {
  /** ข้อความบอกสถานะสำหรับ screen reader */
  label?: string;
  children: React.ReactNode;
}

/** ครอบกลุ่ม skeleton เพื่อประกาศสถานะกำลังโหลด */
export const SkeletonGroup: React.FC<SkeletonGroupProps> = ({ label = 'กำลังโหลดข้อมูล', children }) => (
  <div role="status" aria-busy="true" aria-live="polite" className="flex flex-col gap-3">
    <span className="sr-only">{label}</span>
    {children}
  </div>
);
